import { createContext, useContext, useEffect, useState, ReactNode } from "react";

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  email: string | null;
  login: (access: string, refresh: string, email: string) => void;
  logout: () => void;
}

const Ctx = createContext<AuthState | null>(null);

const STORAGE_KEY = "strangcalc.auth";

export function AuthProvider({ children }: { children: ReactNode }) {
  const [token, setToken] = useState<string | null>(null);
  const [refreshToken, setRefreshToken] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      try {
        const v = JSON.parse(raw);
        setToken(v.token);
        setRefreshToken(v.refreshToken);
        setEmail(v.email);
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  }, []);

  function login(access: string, refresh: string, em: string) {
    setToken(access);
    setRefreshToken(refresh);
    setEmail(em);
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ token: access, refreshToken: refresh, email: em }));
  }
  function logout() {
    setToken(null);
    setRefreshToken(null);
    setEmail(null);
    localStorage.removeItem(STORAGE_KEY);
  }

  return <Ctx.Provider value={{ token, refreshToken, email, login, logout }}>{children}</Ctx.Provider>;
}

export function useAuth(): AuthState {
  const v = useContext(Ctx);
  if (!v) throw new Error("useAuth outside provider");
  return v;
}
